import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { v4 as getUUID } from 'uuid';
import { MDText } from 'i18n-react';
import { withLocale, TSymbolProp } from '@adsk/bim360-matrix-react-helpers/es/locale';
import Label from '@adsk/bim360-matrix-react-label';
import './_FileInput.scss';

/**
 * A FileInput component
 */
export class FileInput extends React.Component {
  /**
   * constructor
   */
  constructor(props) {
    super(props);
    this.state = {};
    this.handleFileChoose = this.handleFileChoose.bind(this);
    this.id = getUUID();
  }

  handleFileChoose(event) {
    const files = event.target.files;
    const fileNames = Array.prototype.map.call(files, file => file.name).join(',');
    this.setState({ fileNames });
    this.props.onChange(event);
  }

  /**
   * render function
   */
  render() {
    const className = classNames(this.props.className, 'FileInput');
    const textClassName = classNames('FileInput__input-text', {
      'FileInput__input-text--placeholder': !this.state.fileNames
    });
    const buttonClassNames = classNames('FileInput__button', { disabled: this.props.disabled });
    // EDGE bug! keep the input and label elements siblings https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8282613/
    return (
      <div className="FileInput__container">
        <Label htmlFor={this.id} className={className} style={this.props.style}>
          <div className={textClassName} data-testid="FileInput__input-text">
            {this.state.fileNames ||
              this.props.placeholderText ||
              this.props[TSymbolProp].translate('FILE_INPUT_DEFAULT_PLACEHOLDER')}
          </div>
          <div className={buttonClassNames} data-testid="FileInput__button" role="button">
            {this.props.buttonText ||
              this.props[TSymbolProp].translate('FILE_INPUT_DEFAULT_BUTTON')}
          </div>
        </Label>
        <input
          id={this.id}
          data-testid="FileInput__input"
          type="file"
          onChange={this.handleFileChoose}
          disabled={this.props.disabled}
          accept={this.props.accept}
          multiple={this.props.multiple}
          style={{ opacity: 0, height: 0, maxWidth: 0 }}
        />
      </div>
    );
  }
}

FileInput.propTypes = {
  /**
   * whether to accept specific file extensions (separated by comma)
   */
  accept: PropTypes.string,
  /**
   * custom className
   */
  className: PropTypes.string,
  /**
   * whether to disable the component
   */
  disabled: PropTypes.bool,
  /**
   * the callback for handling file select
   */
  onChange: PropTypes.func.isRequired,
  /**
   * inline style
   */
  style: PropTypes.object,
  /**
   * whether to support select of multiple files
   */
  multiple: PropTypes.bool,
  /**
   * placeholder text - overrides the default value that comes from locale
   */
  placeholderText: PropTypes.string,
  /**
   * button text - overrides the default value that comes from locale
   */
  buttonText: PropTypes.string,
  /**
   * locale for button text and placeholder text
   */
  locale: PropTypes.string
};

export default withLocale(FileInput, ({ locale }) => new MDText(require(`./i18n/${locale}.json`)));
